import styled from 'styled-components';

export const Banner = styled.section`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px 12px;

  & > div:first-child {
    flex: 1 1 160px;
  }

  padding: 10px 12px;
  background: rgba(0, 0, 0, .25);
  border-left: 3px solid ${props => props.$highlight ? 'var(--accent)' : 'transparent'};
`;

export const Title = styled.h2`
  font-size: 17px;
`;

export const Hint = styled.p`
  margin: 2px 0 0;
  color: var(--muted);
  font-size: 13px;
`;

/** A result both players see until dismissed: coin flips, or hands shown by Lass. */
export const Notice = styled.div`
  flex: 1 1 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 6px 10px;
  border-radius: 8px;
  background: rgba(255, 203, 5, .12);
  font-size: 14px;

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }
`;
